import { Field } from "react-final-form";
import MuiTextField from "@mui/material/TextField";
import Slider from "@mui/material/Slider";
import Box from "@mui/material/Box";
import type { FieldRenderProps } from "react-final-form";

interface RangeInputFieldProps {
  name: string;
  fromField: string;
  toField: string;
  label?: string;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  formatText?: (
    from: number | undefined,
    to: number | undefined,
    params: { min: number; max: number; unit: string }
  ) => string;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  optional?: boolean;
  [key: string]: any;
}

export function RangeInputField({
  name,
  fromField,
  toField,
  label,
  min = 0,
  max = 100,
  step = 1,
  unit = "",
  formatText = (from, to, params) =>
    `От ${from || params.min} ${params.unit} — До ${to || params.max} ${params.unit}`,
  helperText,
  disabled,
  fullWidth,
  optional,
  ...rest
}: RangeInputFieldProps) {
  return (
    <Box sx={{ width: fullWidth ? "100%" : "auto" }}>
      <Field
        name={fromField}
        parse={(value) => {
          if (optional && value == min) return undefined;
          return value;
        }}
        render={({
          input: { onChange: onChangeFrom, value: valueFrom },
        }: FieldRenderProps<number | undefined>) => (
          <Field
            name={toField}
            parse={(value) => {
              if (optional && value == max) return undefined;
              return value;
            }}
            render={({
              input: { onChange: onChangeTo, value: valueTo },
            }: FieldRenderProps<number | undefined>) => {
              const sliderFrom = valueFrom || min;
              const sliderTo = valueTo || max;

              return (
                <Box>
                  <MuiTextField
                    {...rest}
                    name={name}
                    label={label}
                    value={formatText(sliderFrom, sliderTo, { min, max, unit })}
                    helperText={helperText}
                    disabled={disabled}
                    fullWidth={fullWidth}
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        cursor: "default",
                      },
                    }}
                  />
                  <Box sx={{ mt: -2 }}>
                    <Slider
                      value={[sliderFrom, sliderTo]}
                      onChange={(_, [newFrom, newTo]) => {
                        onChangeFrom(newFrom);
                        onChangeTo(newTo);
                      }}
                      min={min}
                      max={max}
                      step={step}
                      disabled={disabled}
                      valueLabelDisplay="auto"
                      sx={{
                        "& .MuiSlider-thumb": {
                          width: 20,
                          height: 20,
                        },
                      }}
                    />
                  </Box>
                </Box>
              );
            }}
          />
        )}
      />
    </Box>
  );
}
